// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "warning-3wGzm";
var _4 = "icon-30ygT";
export { _1 as "__esModule", _2 as "mobile", _3 as "warning", _4 as "icon" }
export default { "__esModule": _1, "mobile": _2, "warning": _3, "icon": _4 }
